import { useSnapshot } from "valtio"

import AguserApi from "../state/AguserApi"
import { Buffer } from 'buffer'
import {
  AgmodalStore,
  EntityV2Store,
  configStore,
  creditAppStore,
  creditformStore,
  loginStore,
  routerStore,
} from "../state/CommonState"
import { CreditFormType, EntityTypeV2 } from "../state/Types"
import EntityApi from "../state/entities-api"
import { City, Country, State } from "country-state-city"
import { useEffect, useRef, useState } from "react"
import { BsFillEyeFill } from "react-icons/bs"
import { MdDelete } from "react-icons/md"
import { HiMiniDocumentCheck } from "react-icons/hi2"
import { ImCancelCircle } from "react-icons/im"
import { BiPlus } from "react-icons/bi"
import off from "../../src/components/off.png"
import on from "../../src/components/on.png"
import { dtactionStore } from "../dtactions/dtaction-store"
import { ReactComponent as Loader } from "../assets/loader.svg"
// import { loader } from "../util/loader"

//import { Col12, Col1,Col2, Col3, Col4, Col5, Col6, Columns } from "../Controls";
import {
  Col12,
  Col1,
  Col2,
  Col3,
  Col4,
  Col8,
  Col7,
  Col5,
  Cols,
  Col6,
  Columns,
} from "../Controls"

import { loader } from "../util/loader"
import { currencyList } from "../StaticData"
import CreditsApis from "../state/credit-api"
import { RiFolderDownloadFill } from "react-icons/ri"
import { LuUpload } from "react-icons/lu"
import Api from "../state/Api"
import { CREDIT_STATUS, CREDIT_APPLICATION_ACTIONS } from "../util/constants"
import RoleUtils from "../util/RoleUtils"
import EntityUtils from "../util/entityUtils"
import EntityV2Api from "../state/entities-api"
import Utils from "../util/Utils"
import TenantUtils from "../util/tenant.utils"


export default function EditCreditApproval(props) {
  const Entity = EntityV2Store.EntityRec
  const Form = creditformStore.CreditformRec
  const userRole = creditAppStore.role
  const [FormUserStatus, setFormUserStatus] = useState("")
  const [errors, setErrors] = useState({})
  const [pendingErrors, setPendingErrors] = useState({})
  const [approveCheckbox, setApproveCheckbox] = useState(false)
  const [approvalStatus, setApprovalStatus] = useState(null)
  const [message, setMessage] = useState("")
  const [downloadFormData, setDownloadFormData] = useState({})
  const [cursor, setCursor] = useState(0)
  const [subbtnstatus, setsubbtnstatus] = useState(false)
  const ref = useRef(null)
  const hiddenFileInput1 = useRef()
  const hiddenFileInput2 = useRef()
  let title = ""
  switch (props.mode) {
    case "edit":
      title = `Modify (${Entity?._id}) ${Entity?.status}`
      break
    case "view":
      title = `View (${Entity?._id}) ${Entity?.status}`
      break
    case "new":
      title = "Create Entity"
      break
    default:
      title = "Entity"
      break
  }
  useSnapshot(EntityV2Store)
  useSnapshot(creditformStore)
  useSnapshot(loader)
  useEffect(() => {
    const input = ref.current
  }, [ref, cursor])

  useEffect(() => {
    // console.log("kkkc",creditAppStore.role);
    const CreditFormStatus = creditformStore.CreditformRec
    if (CreditFormStatus.role === "SALES") {
      setFormUserStatus(CreditFormStatus.action)
    } else if (CreditFormStatus.role === "FINANCE") {
      setFormUserStatus(CreditFormStatus.action)
    }
    if (isSignedCopyReAppFin()){
      Form.documents[0].fileLink =''
    }
    EntityV2Api.viewEntity(CreditFormStatus.entityId)
  }, [])

  useEffect(() => {
    if (!Form.riskEvaluation) {
      Form['riskEvaluation'] = {
        name: "",
        remarks: "",
        document : {
          name: "Risk Evaluation Document",
          fileName: "riskEvaluationDoc",
          pkey: "",
          fileLink: "",
        }
      }
    
    } 
  }, [])

  const handleVerifyRadioChange = (event) => {
    Form.remarks = ""
    setApprovalStatus(event.target.value)
    setApproveCheckbox(true)
    setMessage("")
  }

  const handleMessageChange = (e) => {
    Form.remarks = e.target.value
  }

  function isSalesPending() {
    return Form.action === CREDIT_APPLICATION_ACTIONS.APP_PEN_SALES
  }
  function isFinancePending() {
    return Form.action === CREDIT_APPLICATION_ACTIONS.APP_PEN_FINANCE
  }
  function isMoreCreditAppPending() {
    return Form.action === CREDIT_APPLICATION_ACTIONS.APP_PEN_ISMORECREDITAPP
  }
  function isSignedCopyUploadPen() {
    return Form.action === CREDIT_APPLICATION_ACTIONS.UPL_SGN_COPY
  }
  function isSignedCopyAppFin() {
    return Form.action === CREDIT_APPLICATION_ACTIONS.UPLSGN_APP_FIN
  }
  function isSignedCopyReAppFin() {
    return Form.action === CREDIT_APPLICATION_ACTIONS.REUPLD_SGN_APP
  }
  function isUserSales() {
    return Form.role === "SALES"
  }
  function isUserFinance() {
    return Form.role === "FINANCE"
  }

  const timelinepushfn = (r) => {
    let timeline = {
      date: Date.now(),
      event: r,
      user: loginStore.email,
      role: RoleUtils.getUserRole(),
    }
    Form.timeline.push(timeline)
  }
  const handleSubmit = async (e) => {   
    e.preventDefault()
    setsubbtnstatus(true)
    if (isSalesPending() || isMoreCreditAppPending()) {
      if (approvalStatus === "approve") {
        const chkBox = document.getElementById("approveChkbox").checked
        if (chkBox) {
          let statuses
          if (Utils.creditCategory_1(Form.creditlimit , Form.duration)){
           statuses = {
            status: CREDIT_STATUS.SIGCPYUPLOAD,
            action: Form.action,
            updatedBy: loginStore.email,
          }
        }else if(Utils.creditCategory_3(Form.creditlimit , Form.duration)){
          statuses = {
            status: CREDIT_STATUS.ISMORECREDITAPP,
            action: Form.action,
            updatedBy: loginStore.email,
          }
          }
          else if(Utils.creditCategory_2(Form.creditlimit , Form.duration)){
            statuses = {
              status: CREDIT_STATUS.ISMORECREDITAPP,
              action: Form.action,
              updatedBy: loginStore.email,
            }
            }
          // Form.salesstatus = CREDIT_STATUS.APPSALES
          // Form.status = CREDIT_STATUS.APPPENFINANCE;
          // Form.finstatus = CREDIT_STATUS.APPPENFINANCE;
          await timelinepushfn(CREDIT_APPLICATION_ACTIONS.APPROVED_SALES)
          let dataUpdate = {
            formdata: Form,
            statuses: statuses,
          }
          await CreditsApis.updateStatus(dataUpdate, setsubbtnstatus)
        } else {
          setsubbtnstatus(false)
        }

      } else if (approvalStatus === "reject") {
        if (Form.remarks.trim().length < 1) {
          setsubbtnstatus(false)
          return configStore.setModalMessage("Please enter remarks , it should contain atleast 3 characters")
        }
        if (Form.remarks.trim().length < 3) {
          setsubbtnstatus(false)
          return configStore.setModalMessage("Remarks should contain atleast 3 characters")
        }
        let newForm = new CreditFormType()
        Form.riskEvaluation = newForm.riskEvaluation
        let statuses = {
          status: CREDIT_STATUS.REJECTED,
          action: CREDIT_APPLICATION_ACTIONS.APP_PEN_SALES,
          updatedBy: loginStore.email,
          rejectedrole: Form.role,
        }
        if(isMoreCreditAppPending()){
          statuses.action = CREDIT_APPLICATION_ACTIONS.APP_PEN_ISMORECREDITAPP
        }
        await timelinepushfn(CREDIT_APPLICATION_ACTIONS.REJ_SALES)
        let dataUpdate = {
          formdata: Form,
          statuses: statuses,
        }
        await CreditsApis.updateStatus(dataUpdate, setsubbtnstatus)
      }else {
        setsubbtnstatus(false)
      }

    } else if (isFinancePending() ) {
      if (approvalStatus === "approve") {
        let ckValidation =await CheckFinanceValidation()
        if(ckValidation){
          let statuses = {
            status: CREDIT_STATUS.SIGCPYUPLOAD,
            action: Form.action,
            updatedBy: loginStore.email,
          }
          // Form.finstatus = CREDIT_STATUS.APPFINANCE
          //   Form.status = CREDIT_STATUS.SIGCPYUPLOAD;
          //   Form.salesstatus = CREDIT_STATUS.SIGCPYUPLOAD;
          await timelinepushfn(CREDIT_APPLICATION_ACTIONS.APPROVED_FINANCE)
          let dataUpdate = {
            formdata: Form,
            statuses: statuses,
          }
          await CreditsApis.updateStatus(dataUpdate, setsubbtnstatus)
        }else {
          setsubbtnstatus(false)
        }

      } else if (approvalStatus === "reject") {
        if (Form.remarks.trim().length < 1) {
          setsubbtnstatus(false)
          return configStore.setModalMessage("Please provide remarks or comments for the rejection.")
        }
        if (Form.remarks.trim().length < 3) {
          setsubbtnstatus(false)
          return configStore.setModalMessage("Remarks should contain atleast 3 characters")
        }
        let statuses = {
          status: CREDIT_STATUS.REJECTED,
          action: CREDIT_APPLICATION_ACTIONS.APP_PEN_FINANCE,
          updatedBy: loginStore.email,
          rejectedrole: Form.role,
        }
        await timelinepushfn(CREDIT_APPLICATION_ACTIONS.REJ_FINANCE)
        let dataUpdate = {
          formdata: Form,
          statuses: statuses,
        }
        await CreditsApis.updateStatus(dataUpdate, setsubbtnstatus)
      }else {
        setsubbtnstatus(false)
      }

    } else if (isSignedCopyUploadPen()) {
      if (Form.documents[0].fileLink.length > 0) {
        let statuses = {
          status: CREDIT_STATUS.SIGCPYUPLOADED,
          action: Form.action,
          updatedBy: loginStore.email,
        }
        await timelinepushfn(CREDIT_APPLICATION_ACTIONS.SGN_COPY_UPLD)
        let dataUpdate = {
          formdata: Form,
          statuses: statuses,
        }
        await CreditsApis.updateStatus(dataUpdate, setsubbtnstatus)
      } else {
        configStore.setModalMessage("Please Upload the signed copy")
        setsubbtnstatus(false)
      }
    }else if (isSignedCopyAppFin()){
        if (approvalStatus === "approve") {
          const chkBox = document.getElementById("approveChkbox").checked
          if (chkBox) {
            let statuses = {
              status: CREDIT_STATUS.VERIFIED,
              action: Form.action,
              updatedBy: loginStore.email,
            }
            // Form.salesstatus = CREDIT_STATUS.APPSALES
            // Form.status = CREDIT_STATUS.APPPENFINANCE;
            // Form.finstatus = CREDIT_STATUS.APPPENFINANCE;
            await timelinepushfn(CREDIT_APPLICATION_ACTIONS.SGN_APP_FIN)
            await timelinepushfn(CREDIT_APPLICATION_ACTIONS.VERIFIED)
            let dataUpdate = {
              formdata: Form,
              statuses: statuses,
            }
            await CreditsApis.updateStatus(dataUpdate, setsubbtnstatus)
          } else {
            setsubbtnstatus(false)
          }
  
        } else if (approvalStatus === "reject") {
          if (Form.remarks.trim().length < 1) {
            setsubbtnstatus(false)
            return configStore.setModalMessage("Please enter remarks , it should contain atleast 3 characters")
          }
          if (Form.remarks.trim().length < 3) {
            setsubbtnstatus(false)
            return configStore.setModalMessage("Remarks should contain atleast 3 characters")
          }
          let statuses = {
            status: CREDIT_STATUS.SIGNED_REUPL_PEN,
            action: CREDIT_APPLICATION_ACTIONS.UPLSGN_APP_FIN,
            updatedBy: loginStore.email,
            rejectedrole: Form.role,
          }
          await timelinepushfn(CREDIT_APPLICATION_ACTIONS.SGN_APP_REJFIN)
          let dataUpdate = {
            formdata: Form,
            statuses: statuses,
          }
          await CreditsApis.updateStatus(dataUpdate, setsubbtnstatus)
        }
        else {
          setsubbtnstatus(false)
        }
  
      
    }else if (isSignedCopyReAppFin()){
      if (Form.documents[0].fileLink.length > 0) {
        let statuses = {
          status: CREDIT_STATUS.SIGCPYUPLOADED,
          action: Form.action,
          updatedBy: loginStore.email,
        }
        await timelinepushfn(CREDIT_APPLICATION_ACTIONS.SGN_APP_REUPLD)
        let dataUpdate = {
          formdata: Form,
          statuses: statuses,
        }
        await CreditsApis.updateStatus(dataUpdate, setsubbtnstatus)
      } else {
        configStore.setModalMessage("Please Upload the signed copy")
        setsubbtnstatus(false)
      }

    
  }
    // setsubbtnstatus(false)
  }
  const delDoc = (r) => {
    if(r === 'signCpy'){
    Form.documents[0].fileLink = ""
    Form.documents[0].pkey = ""
    }else if( r === 'riskEvalDoc'){
    Form.riskEvaluation.document.fileLink = ""
    Form.riskEvaluation.document.pkey = ""
    }
  }
  // console.log(Form)
  const handleChange = (e, r, z, a) => {
    setCursor(e.target.selectionStart)
    if (r === "creditagency" || r === "creditscore" || r === "overallcreditscore") {
      let re = new RegExp("^([A-Za-z0-9- ]{0,100})$")
      if (!re.test(e.target.value)) {
        return null
      }
    }
    if(z){
      if (typeof errors['riskEvaluation'] !== "object" || errors['riskEvaluation'] === null) {
        errors['riskEvaluation'] = {}; 
         }
      errors['riskEvaluation'][z]=''    
      return  Form[r][z] = e.target.value
    }else {
    Form[r] = e.target.value
    }
  }

  function change(files, filetype, i) {
    const formData = new FormData()
    formData.append("myFile", files[0])
    formData.append("label", filetype)
    formData.append("key", i)
    fetch(`${process.env.REACT_APP_FILE_SERVER}/api/v1/filestore/storefile`, {
      method: "POST",
      headers: Api.H1(),
      credentials: Utils.shouldSendCredentials(process.env.REACT_APP_FILE_SERVER) ? 'include' : 'omit',
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.error) configStore.setModalMessage(data.error)
        else {
          if(filetype === 'SignedCredit'){
          Form.documents[0].fileLink = data?.key?.filename
          Form.documents[0].pkey = data?.key?.pkey
          }else if(filetype === 'riskEvalDoc'){
            Form.riskEvaluation.document.fileLink = data?.key?.filename
            Form.riskEvaluation.document.pkey = data?.key?.pkey
            if (typeof errors['riskEvaluation'] !== "object" || errors['riskEvaluation'] === null) {
              errors['riskEvaluation'] = {}; 
               }
            errors['riskEvaluation'].document = ''   
          }
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }
  function isAgragaAdmin() {
    return RoleUtils.getUserRole().toLowerCase() === `${process.env.REACT_APP_ENTERPRISE_NAME_SMALLCASE} admin`
  }
  function isAgragaSales() {
    return RoleUtils.getUserRole().toLowerCase() === "sales"
  }
  function isAgragaFinance() {
    return RoleUtils.getUserRole().toLowerCase() === "finance"
  }
  const toggleSoleProp = () => {
    return (Entity.vendor.isSoleProp = !Entity.vendor.isSoleProp)
  }

  async function  CheckFinanceValidation (){
    let valid = true 
    let fieldToCheck = [
      { title: "Name", field: "name", required: true },
      { title: "Remarks", field: "remarks", required: true },
      { title: "Document", field: "document", required: true },
    ]
   await Promise.all( fieldToCheck.map((x,i)=> {
       let value
       if(x.title === 'Document'){
        value = Form.riskEvaluation[x.field].fileLink
       }else{
        value = Form.riskEvaluation[x.field]?.trim()
       }
       if(!value){
        if (typeof errors['riskEvaluation'] !== "object" || errors['riskEvaluation'] === null) {
          errors['riskEvaluation'] = {}; 
           }
        valid = false
        errors.riskEvaluation[x.field]=`${x.title} is required`
        setErrors(errors)
       }

    }))
   return valid

  }
  return (
    <>
      <div class="main-content" style={{ zoom: "0.9" }}>
        <div className="header-wrapper">
          <div className="left-header">
            <div className="page-heading" >

              <span className="heading">
                {Form.entityId}/{FormUserStatus}
              </span>

            </div>
          </div>
        </div>
        <section
          class="section section-padding"
          style={{ backgroundColor: "#eee", paddingTop: "0px" }}
        >
          <Cols>
            <Col7 style={{ zoom: "0.9" }}>
              <Cols>
                <Col4 style={{ color: "darkblue" }}>Entity Name</Col4>
                <Col7>{Form.entityName}</Col7>
              </Cols>
              {EntityUtils.isIndia(Entity) ? <>
                <Cols>
                <Col4 style={{ color: "darkblue" }}>PAN Number</Col4>
                <Col7>{Form?.panNum}</Col7>
              </Cols>
              
              <Cols>
                <Col4 style={{ color: "darkblue" }}>GST Numbers</Col4>
                <Col7>
                  {Form.gstList?.map((r, i) => {
                    return (
                      <button className="pd-2 button-caf-gst">{r.gst}</button>
                    )
                  })}
                </Col7>
              </Cols>
              </>:  <Cols>
                <Col4 style={{ color: "darkblue" }}>TIN Number</Col4>
                <Col7>{Form?.tinNum}</Col7>
              </Cols>
              }

            

                <>
                <p className="is-size-5 has-text-weight-bold" >Cross-Border</p>
                  <Cols>
                <Col4 style={{ color: "darkblue" }}>{process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE} Branch</Col4>
                <Col7>{Form?.customer?.crossBorder?.agragaBranch}</Col7>
              </Cols>
              <Cols>
                <Col4 style={{ color: "darkblue" }}>Relationship Manager</Col4>
                <Col7>{Form?.customer?.crossBorder?.relationshipManager}</Col7>
              </Cols>
              <Cols>
                <Col4 style={{ color: "darkblue" }}>Customer Service</Col4>
                <Col7>{Form?.customer?.crossBorder?.customerService}</Col7>
              </Cols>
            
              </>
             
              {Form?.customer?.domesticTransport?.customerService.length > 3 && <>
                <p className="is-size-5 has-text-weight-bold" >Domestic-Transport</p>
                <Cols>
                <Col4 style={{ color: "darkblue" }}>{process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE} Branch</Col4>
                <Col7>{Form?.customer?.domesticTransport?.agragaBranch} </Col7>
              </Cols>
              <Cols>
                <Col4 style={{ color: "darkblue" }}>Relationship Manager</Col4>
                <Col7>{Form?.customer?.domesticTransport?.relationshipManager}</Col7>
              </Cols>
              <Cols>
                <Col4 style={{ color: "darkblue" }}>Customer Service</Col4>
                <Col7>{Form?.customer?.domesticTransport?.customerService}</Col7>
              </Cols>
              <Cols>
                <Col4 style={{ color: "darkblue" }}>Branch Operation Manager</Col4>
                <Col7>{Form?.customer?.domesticTransport?.branchOperationManager} </Col7>
              </Cols>
              </>
              }
            </Col7>
            <Col5>
              <div
                style={{
                  fontWeight: "bold",
                  color: "purple",
                  fontSize: "1.1rem",
                }}
                className=""
              >
                TimeLine
              </div>
              <table
                className="table is-fullwidth is-narrow timeline_table"
                style={{ zoom: "0.8" }}
              >
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Event</th>
                    <th>User</th>
                    <th>Role</th>
                  </tr>
                </thead>
                <tbody>
                  {Form.timeline.map((r, i) => {
                    return <>
                      <tr key={i}>
                        <td>{new Date(Form.timeline[i].date).toLocaleString()}</td>
                        <td>{Form.timeline[i].event}</td>
                        <td>{Form?.timeline[i]?.user}</td>
                        <td>{Form.timeline[i].role}</td>
                      </tr>
                    </>
                  })}
                </tbody>
              </table>
            </Col5>
          </Cols>
        </section>
        {
          // (
          // function () {
          //     if (action._id.actionName == 'Document Verification') return <DtactionsDocverify setSubmitCallback={setSubmitCallback} />
          //     else if (action._id.actionName == 'Final Document Verification') return <DtactionsFinaldocverify setSubmitCallback={setSubmitCallback} />
          //     else if (action._id.actionName == 'Initiate Advance') return <DtactionsPayment setSubmitCallback={setSubmitCallback} />
          //     else return <DtactionsBalance setSubmitCallback={setSubmitCallback} />
          // }
          // )()
        }

        <hr></hr>
        <form className="p-2">
          <p className="is-size-5 has-text-weight-bold">Credit Details</p>
          <Columns>
            <Col4>
              <div className="is-flex  is-flex-direction-column is-one-third">
                <label className="has-text-weight-semibold">Duration*</label>
                {/* <input className="py-1" placeholder="In days"  value={Form?.duration}></input> */}
                <input
                  type="text"
                  className="input is-small "
                  value={Form?.duration}
                  // ref={refEntityName}
                  disabled

                // onChange={(e) => handleChange(e, "entityName")}
                />
              </div>
            </Col4>
          </Columns>
          <Columns>
            <Col4>
              <div className="is-flex  is-flex-direction-column is-one-third">
                <label className="has-text-weight-semibold">
                  Amount*
                </label>
                <input
                  type="text"
                  className="input is-small "
                  value={Form?.creditlimit}
                  // ref={refEntityName}
                  disabled

                // onChange={(e) => handleChange(e, "entityName")}
                // natureofbusiness
                />
              </div>
            </Col4>
          </Columns>
          <Columns>
            <Col4>
              <div className="is-flex  is-flex-direction-column is-one-third">
                <label className="has-text-weight-semibold">
                  Nature of Business
                </label>

                <select disabled className="py-1 px-2" name="natureofbusiness">
                  <option>{Form?.natureofbusiness}</option>
                </select>
              </div>
            </Col4>
          </Columns>

          <Columns>
            <Col4>
              <div className="is-flex  is-flex-direction-column is-one-third">
                <label className="has-text-weight-semibold">
                  Nature of Cargo
                </label>
                <select disabled className="py-1 px-2" name="natureofbusiness">
                  <option>{Form?.natureofcargo}</option>
                </select>
              </div>
            </Col4>
          </Columns>
          <Columns>
            <Col4>
              <div className="is-flex  is-flex-direction-column is-one-third">
                <label className="has-text-weight-semibold">Turnover</label>
                <div>
                  <select
                    disabled
                    className="py-1 wd_20 px-2"
                    name="Currency"
                    value={Form?.turnover?.currency}
                  >
                    {currencyList.map((r, i) => {
                      return (
                        <option key={i} value={r}>
                          {r}
                        </option>
                      )
                    })}
                  </select>
                  <input
                    className="py-1 wd_80 px-2"
                    placeholder="Value"
                    type="text"
                    value={Form?.turnover?.value}
                    // ref={refEntityName}
                    disabled
                  ></input>
                </div>
              </div>
            </Col4>
          </Columns>
          <hr></hr>
          {Form.graceDetails?.selected ? (<>
            <Columns>
            <Col4>
              <div className="is-flex  is-flex-direction-column is-one-third">
                <label className="has-text-weight-semibold">Grace Days</label>
                <input
                  type="text"
                  className="input is-small "
                  value={Form?.graceDetails.days}
                  disabled
                />
              </div>
            </Col4>
         
          </Columns>
          <Columns>
            <Col4>
              <div className="is-flex  is-flex-direction-column is-one-third">
                <label className="has-text-weight-semibold">Currency</label>
                <input
                  type="text"
                  className="input is-small "
                  value={Form?.graceDetails.currency}
                  disabled
                />
              </div>
            </Col4>
            <Col4>
              <div className="is-flex  is-flex-direction-column is-one-third">
                <label className="has-text-weight-semibold">Amount</label>
                <input
                  type="text"
                  className="input is-small "
                  value={Form?.graceDetails.amount}
                  disabled
                />
              </div>
            </Col4>         
          </Columns>
          </> ) : null
          }
          <hr></hr>
          <p className="is-size-5 has-text-weight-bold">Financial Summary*</p>
          <table className="table_caf wd_80">
            <thead>
              <td>Product</td>
              <td>Total Potential</td>
              <td>Monthly Revenue Projected</td>
            </thead>
            <tbody>
              <tr>
                <td className="px-2">International</td>
                <td>
                  <span></span>
                  <input
                    type="text"
                    className="inp_table_caf"
                    value={
                      Form?.financialsummary?.International?.totalpotential
                    }
                    disabled
                  />
                </td>
                <td>
                  <input
                    type="text"
                    className="inp_table_caf"
                    value={
                      Form?.financialsummary?.International?.monthlyrevenue
                    }
                    disabled
                  />
                </td>
              </tr>
              { TenantUtils.isAgraga() ? <>
   <tr>
                <td className="px-2">Domestic Transport</td>
                <td>
                  <input
                    type="text"
                    className="inp_table_caf"
                    value={Form?.financialsummary?.Domestic?.totalpotential}
                    disabled
                  />
                </td>
                <td>
                  <input
                    type="text"
                    className="inp_table_caf"
                    value={Form?.financialsummary?.Domestic?.monthlyrevenue}
                    disabled
                  />
                </td>
              </tr>
              </> : null

              }
           
            </tbody>
          </table>
          <p className="is-size-5 has-text-weight-bold mt-4">Finance*</p>
          <div className="is-flex ">
            <table className="table_caf_fin wd_80">
              <thead>
                <td>Customer Contact Person</td>
                <td>Description/Department</td>
                <td>Contact Number</td>
                <td>Email</td>
                {/* <td></td> */}
              </thead>
              <tbody>
                {Form.finance?.map((r, i) => {
                  return (<tr>
                    <td>
                      <input
                        type="text"
                        className="inp_table_caf is-size-6"
                        value={r.customercontact}
                        disabled
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="inp_table_caf is-size-6"
                        value={r.department}
                        disabled
                      />
                    </td>
                    <td className="is-flex wd_100">
                      <span className="mt-4 pl-2 ">{r?.countryCode}</span>
                      <input
                        type="text"
                        className="inp_table_caf is-size-6"
                        value={r?.contactnum}
                        disabled
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="inp_table_caf is-size-6"
                        value={r?.email}
                        disabled
                      />
                    </td>

                  </tr>)
                })}

                {/* })} */}
              </tbody>
            </table>
          </div>

          <p className="is-size-5 has-text-weight-bold mt-4">
            Finance Escalation
          </p>
          <table className="table_caf_fin wd_80">
            <thead>
              <td>Customer Contact Person</td>
              <td>Description/Department</td>
              <td>Contact Number</td>
              <td>Email</td>
            </thead>
            <tbody>
              {Form.financeescalation?.map((r, i) => {
                return (
                  <tr>
                    <td>
                      <input
                        type="text"
                        className="inp_table_caf"
                        value={r?.customercontact}
                        disabled
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="inp_table_caf"
                        value={r?.department}
                        disabled
                      />
                    </td>
                    <td className="is-flex wd_100">
                      {r.contactnum &&
                        <span className="contNumcodespn mt-4">{r?.countryCode}</span>
                      }
                      <input
                        type="text"
                        className="inp_table_caf"
                        value={r?.contactnum}
                        disabled
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="inp_table_caf"
                        value={r?.email}
                        disabled
                      />
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>

          <hr></hr>

          {(
            <>
              {((isSalesPending() || isMoreCreditAppPending() ) && isUserSales()) && (
                <p className="is-size-5 has-text-weight-bold">
                  Sales Approvals for this Credit Facility
                </p>

              )
              }
              {((isFinancePending() )  && isUserFinance()) && (
                <p className="is-size-5 has-text-weight-bold">
                 {isFinancePending() ? "Finance" : ""}
                  Approval for this Credit Facility
                </p>
              )
              }
              {(isSignedCopyAppFin() && isUserFinance()) && (
            <>
             
              <p className="is-flex is-align-items-center">
                View Signed Credit application{" "}


                {Form.documents[0].fileLink.length > 0 ? (
                  <>
                    <span className="ml-2 mr-1 is-size-4 mt-2">
                      <a
                        href={
                          process.env.REACT_APP_FILE_SERVER +
                          "/api/v1/filestore/getfile/" +
                          Form.documents[0]?.pkey +
                          "/" +
                          Form.documents[0]?.fileLink
                        }
                        target="_blank"
                        rel="noreferrer"
                        alt=""
                      >
                        <BsFillEyeFill />
                      </a>
                    </span>
                    
                    </>) : <>
                    
                    </>
                }
              </p>
            </>
          )}
              {(((isSalesPending() || isMoreCreditAppPending() ) && isUserSales()) || ((isFinancePending()  && isUserFinance() ) || (isSignedCopyAppFin() && isUserFinance()))) && (
                <div className="is-flex is-justify-content-space-between">
                  <span className="is-size-6" style={{ marginTop: "1%" }}>
                    <div>
                      <label>
                        <input
                          type="radio"
                          className="is-size-2"
                          name="approvalStatus"
                          value="approve"
                          checked={approvalStatus === "approve"}
                          onChange={handleVerifyRadioChange}
                        />
                        Approve
                      </label>
                      <label style={{ marginLeft: "10px" }}>
                        <input
                          type="radio"
                          className="is-size-2"
                          name="approvalStatus"
                          value="reject"
                          checked={approvalStatus === "reject"}
                          onChange={handleVerifyRadioChange}
                        />
                        Reject
                      </label>
                    </div>
                  </span>
                </div>
              )}

              {approvalStatus === "reject" && (
                <div>
                  <textarea
                    //  id="rejectremarksid"
                    className="px-2"
                    rows="4"
                    cols="50"
                    placeholder="Enter your Remarks"
                    value={Form.remarks}
                    onChange={handleMessageChange}
                    //onChange={approvebtnnfn}
                    style={{ marginTop: "10px", border: "1px solid #d1d1e0" }}
                  />
                </div>
              )}
              {((isSalesPending()||  isMoreCreditAppPending() || isSignedCopyAppFin()) && approvalStatus === "approve") && (
                <div>
                  Do you want to approve? <span></span>
                  <input
                    type="checkbox"
                    className="is-size-2"
                    name="approvalStatus"
                    // value="approve"
                    id="approveChkbox"
                  // onChange={approvebtnnfn}
                  />
                </div>
              )}
            </>
          )}

          {(isFinancePending()   && approvalStatus === "approve") && (
            <>
            <div className="is-flex">
              <Col4>
                <p className="label is-small" style={{ marginBottom: "0px" }}>
                  Credit Rating Agency
                </p>
                <div className="is-flex">
                  <input
                    type="text"
                    className="input is-small "
                    placeholder="Name"
                    value={Form.creditagency}
                    //value={Branch?.gst}
                    // ref={ref1}
                    id="gst"
                    pattern="[A-Z0-9]{15}"
                    onChange={(e) => handleChange(e, "creditagency")}
                    style={{ width: "80%" }}
                  />
                </div>
              </Col4>
              <Col4>
                <p className="label is-small" style={{ marginBottom: "0px" }}>
                  Credit Score
                </p>
                <div className="is-flex">
                  <input
                    type="text"
                    className="input is-small "
                    placeholder="Score"
                    value={Form.creditscore}
                    //value={Branch?.gst}
                    // ref={ref1}
                    id="gst"
                    pattern="[A-Z0-9]{15}"
                    onChange={(e) => handleChange(e, "creditscore")}
                    style={{ width: "80%" }}
                  />
                </div>
              </Col4>
              <Col4>
                <p className="label is-small">Overall Credit Score</p>
                <div className="is-flex">
                  <input
                    type="text"
                    className="input is-small "
                    placeholder="Overall Score"
                    value={Form.overallcreditscore}
                    //value={Branch?.gst}
                    // ref={ref1}
                    id="gst"
                    pattern="[A-Z0-9]{15}"
                    onChange={(e) => handleChange(e, "overallcreditscore")}
                    style={{ width: "80%" }}
                  />
                </div>
              </Col4>
            </div>
            <hr></hr>
            <div className="is-flex">
            <Col4>
              <p
                className="label is-small"
                style={{ fontSize: "15px", marginLeft: "7px" }}
              >
                Invoice discount available
              </p>
              
                
                  <button
                    className="mt-1 is-clickable"
                    type="button"
                    style={{
                      border: "none",
                      backgroundColor: "white",
                    }}
                    onClick={toggleSoleProp}

                    disabled={true}
                  >
                    {Entity?.vendor?.isSoleProp ? (
                      <img height="20px" width="36px" src={on}></img>
                    ) : (
                      <img height="20px" width="36px" src={off}></img>
                    )}
                  </button>
               
              </Col4>
              <Col4>
                <div className="is-flex is-flex-direction-column">
                <p className="label is-small">Invoice Discount Partner</p>

                <select
                  className="select is-small px-2"
                  style={{ width: "80%", border: "1px solid #d1d1e0" }

                  }
                  disabled={true}
                //value={Branch.relationshipManager}
                //{...(isViewMode() ? { disabled: true } : {})}
                //</Col4> onChange={(e) => handleChange(e, "relationshipManager")}
                >
                  <option selected disabled value="">
                    Select Invoice Discount Partner
                  </option>
                  {/* {renderSalesOptions(
                     Object.values(salesList),

                    // Branch?.relationshipManager
                   )} */}
                  <option value="">Details 1</option>
                  <option value="">Details 2</option>
                </select>
                </div>
              </Col4>
            </div>
            <hr></hr>
            <div className="is-flex">
              <Col4>
                <p className="label is-small" style={{ marginBottom: "0px" }}>
                  Virtual Account Number
                </p>
                <div className="is-flex">
                  <input
                    type="text"
                    className="input is-small "
                    //value={Branch?.gst}
                    // ref={ref1}
                    id="gst"
                    pattern="[A-Z0-9]{15}"
                    disabled={true}
                    // onChange={(e) => handleChange(e, "gst")}
                    style={{ width: "80%" }}
                  />
                </div>
              </Col4>
             </div> 
              <hr></hr>
              
              <p className="label is-medium">Risk Evaluation Underwriting</p>
              <div className="is-flex">
              <Col4>
              <div className="is-flex is-flex-direction-column">
                <p className="label is-small pb-2" style={{ marginBottom: "0px" }}>
                Risk Evaluation Underwriting
                </p>
             
                  <input
                    type="text"
                    className="input is-small "
                    value={Form.riskEvaluation.name}
                    // ref={ref1}
                    // id="gst"
                    pattern="[A-Z0-9]{15}"
                    // disabled={true}
                    onChange={(e) => handleChange(e, "riskEvaluation" ,"name" )}
                    style={{ width: "80%" }}
                  />
                  {errors.riskEvaluation?.name &&  
                    <p className="help is-input-danger-message">
                    {errors.riskEvaluation?.name}
                  </p>
                  }
                </div>
              </Col4>
              <Col4>
              <div className="is-flex is-flex-direction-column">
                <p className="label is-small" style={{ marginBottom: "0px" }}>
                  Remarks
                </p>
               
                <textarea
                    //  id="rejectremarksid"
                    className="px-2"
                    rows="4"
                    cols="50"
                    placeholder="Enter your Remarks"
                    value={Form.riskEvaluation.remarks}
                    onChange={(e) => handleChange(e, "riskEvaluation" ,"remarks" )}
                    //onChange={approvebtnnfn}
                    style={{ marginTop: "10px", border: "1px solid #d1d1e0" }}
                  />
                   {errors.riskEvaluation?.remarks &&  
                    <p className="help is-input-danger-message">
                    {errors.riskEvaluation?.remarks}
                  </p>
                  }
                </div>
              </Col4>
              <Col4>
              <p className="label is-small" style={{ marginBottom: "0px" }}>File Upload</p>
              {Form.riskEvaluation.document.fileLink?.length > 0 ? (
                  <>
                    <span className="ml-2 mr-1 is-size-4">
                      <a
                        href={
                          process.env.REACT_APP_FILE_SERVER +
                          "/api/v1/filestore/getfile/" +
                          Form.riskEvaluation.document?.pkey +
                          "/" +
                          Form.riskEvaluation.document?.fileLink
                        }
                        target="_blank"
                        rel="noreferrer"
                        alt=""
                      >
                        <BsFillEyeFill />
                      </a>
                    </span>
                    <span className="icon ml-2 is-size-4 is-clickable">
                      <MdDelete
                        onClick={() => (
                          delDoc("riskEvalDoc"), (hiddenFileInput2.current.value = "")
                        )}
                      />
                    </span></>) : <><a>
                      <span className="icon mt-1 ml-3 is-size-4 ">
                        <LuUpload
                          onClick={() => hiddenFileInput2.current.click()}
                        />
                      </span>
                    </a></>
                }
              <input
                type="file"
                onChange={(e1) => {
                  change(
                    e1.target.files,
                    "riskEvalDoc",
                    Form.entityId
                  )
                }}
                name="image"
                accept="image/gif,image/jpeg,image/jpg,image/png,application/pdf"
                multiple=""
                ref={hiddenFileInput2}
                data-original-title="upload photos"
                style={{ display: "none" }}
              />
               {errors.riskEvaluation?.document &&  
                    <p className="help is-input-danger-message">
                    {errors.riskEvaluation?.document}
                  </p>
                  }
            
              </Col4>
              </div>
          
            </>
          )}

          {((isSignedCopyUploadPen() || isSignedCopyReAppFin())&& isUserSales()) && (
            <>
             { isSignedCopyReAppFin() ? <>
              <p className="is-flex is-align-items-center is-text-bold is-size-5">
                Rejection Remarks : <span className="ml-2 is-size-6"> {Form.remarks}</span>
              </p>
             </> : null

             }

              <p className="is-flex is-align-items-center">
                Download Application{" "}
                <a
                  // href={
                  //   process.env.REACT_APP_API_SERVER +
                  //   "/api/v1/stakeholder/getCreditDocument/" +
                  //   Form.entityId 
                  // }
                  // target="_blank"
                  // rel="noreferrer"
                  // alt=""
                  //   onClick={async () => {
                  //   await CreditsApis.getCafDocs(Form.entityId ,setDownloadFormData )
                  //      console.log(downloadFormData);
                  //       const buffer = Buffer.from(downloadFormData.data);
                  //       const blob = new Blob([buffer]);
                  //       const fileURL = window.URL.createObjectURL(blob);
                  //       console.log(fileURL)
                  //       let alink = document.createElement('a');
                  //       alink.href = fileURL;
                  //       alink.download = `${Form.entityId}.pdf`;
                  //       alink.click();


                  // }}
                  onClick={async () => {
                    let res = await Api.getCafDocumentById(Form.entityId)
                    const buffer = Buffer.from(res)
                    const blob = new Blob([buffer])
                    const fileURL = window.URL.createObjectURL(blob)
                    let alink = document.createElement('a')
                    alink.href = fileURL
                    alink.download = `${Form.entityId}.pdf`
                    alink.click()
                  }}
                >
                  <span className="icon mt-1 ml-3 is-size-4 ">
                    <RiFolderDownloadFill />
                  </span>
                </a>
              </p>
              <p className="is-flex is-align-items-center">
              { isSignedCopyReAppFin()? 'Re-Upload': 'Upload' } Signed Credit application{" "} 


                {Form.documents[0].fileLink.length > 0 ? (
                  <>
                    <span className="ml-2 mr-1 is-size-4">
                      <a
                        href={
                          process.env.REACT_APP_FILE_SERVER +
                          "/api/v1/filestore/getfile/" +
                          Form.documents[0]?.pkey +
                          "/" +
                          Form.documents[0]?.fileLink
                        }
                        target="_blank"
                        rel="noreferrer"
                        alt=""
                      >
                        <BsFillEyeFill />
                      </a>
                    </span>
                    <span className="icon ml-2 is-size-4 is-clickable">
                      <MdDelete
                        onClick={() => (
                          delDoc('signCpy'), (hiddenFileInput1.current.value = "")
                        )}
                      />
                    </span></>) : <><a>
                      <span className="icon mt-1 ml-3 is-size-4 ">
                        <LuUpload
                          onClick={() => hiddenFileInput1.current.click()}
                        />
                      </span>
                    </a></>
                }
              </p>

              <input
                type="file"
                onChange={(e1) => {
                  change(
                    e1.target.files,
                    "SignedCredit",
                    Form.entityId
                  )
                }}
                name="image"
                accept="image/gif,image/jpeg,image/jpg,image/png,application/pdf"
                multiple=""
                ref={hiddenFileInput1}
                data-original-title="upload photos"
                style={{ display: "none" }}
              />
            </>
          )}
          {((isSignedCopyUploadPen() && isUserSales()) || ((isSalesPending() || isMoreCreditAppPending()) && isUserSales()) || (isFinancePending()  && isUserFinance() || (isSignedCopyAppFin() && isUserFinance() ) || ( isSignedCopyReAppFin() && isUserSales()))) &&
            (
              <div>
                <span>
                  <button
                    className="button_cancel"
                    style={{ marginLeft: "3px", paddingLeft: "10px" }}
                    onClick={() => {
                      EntityV2Store.EntityRec.set(new EntityTypeV2())
                      AgmodalStore.pageVisible = false;
                      AgmodalStore.apiCall = true;
                    }}
                  >
                    CANCEL
                  </button>
                  <button
                    className="button_submit"
                    id="approvebtnid"
                    onClick={(e)=>handleSubmit(e)}
                    disabled={subbtnstatus}
                  >
                   {!subbtnstatus ? "SUBMIT" : <Loader className="spinner" />}
                  </button>
                </span>
              </div>
            )
          }
        </form>

        <hr />
      </div>
    </>
  )

  function clearErrorMessages(r) {
    pendingErrors[r] = ""
    errors[r] = ""
    setPendingErrors(pendingErrors)
  }
}
